exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-catalog-card-buttons{width:100%}loans-catalog-card-buttons .buttons-card{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}loans-catalog-card-buttons .buttons-card .btn.btn-app{width:130px;line-height:38px;height:38px}loans-catalog-card-buttons .buttons-card>:first-child{margin-right:15px}loans-catalog-card-buttons .buttons-card.mobile .btn{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansCatalog/loansCatalogCard/loansCatalogCardButtons/loansCatalogCardButtons.scss
// module id = 1817
// module chunks = 0